import React from "react";
import LayoutHOC from "../LayoutHOC";
import useCandidateAppliedJobList from "../../hooks/useCandidateAppliedJobList";

const CandidateJobAppliedJob = ({ id }) => {
  const appliedJobs = useCandidateAppliedJobList(id);

  console.log("Applied Jobs Data:", appliedJobs);

  // Normalize: ensure always array
  const jobsArray = appliedJobs
    ? Array.isArray(appliedJobs.data)
      ? appliedJobs.data
      : [appliedJobs.data]
    : [];

  if (jobsArray.length === 0) {
    return (
      <div className="p-4">
        <p className="text-gray-600">No Candidate applied yet.</p>
      </div>
    );
  }

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">Candidate Applied Jobs</h2>

      <ul className="divide-y divide-gray-200 border rounded-md">
        {jobsArray.map((job, index) => (
          <li
            key={job.id ?? index} // fallback in case no id from API
            className="p-4 flex flex-col gap-2 md:flex-row md:justify-between md:items-center"
          >
            {/* Left: Candidate Info */}
            <div>
              <p className="text-gray-600 text-sm">
                <span className="font-semibold">Candidate Name:</span>{" "}
                {job.name}
              </p>
              <p className="text-gray-600 text-sm">
                <span className="font-semibold">Mobile:</span> {job.mobile}
              </p>
              <p className="text-gray-600 text-sm">
                <span className="font-semibold">Email:</span> {job.email}
              </p>
            </div>

            {/* Right: Job Details */}
            <div className="mt-2 md:mt-0 text-sm">
              <p className="text-gray-600">
                <span className="font-semibold">Status:</span>{" "}
                {job.application_status}
              </p>
              {job.updated_at && (
                <p className="text-gray-700">
                  <span className="font-semibold">Job Status Date:</span>{" "}
                  {new Date(job.updated_at).toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })}
                </p>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LayoutHOC(CandidateJobAppliedJob);
